import { IWebHttpErroResponse } from "./WebHttpErroResponse";

export default class WebHttpErroResponseValidacaoEntity<T = {
    campo: string;
    valor: any;
    mensagem: string;
}[]> extends IWebHttpErroResponse<T> {
    isInstancia(objeto:  any): boolean {
        return objeto !== undefined && objeto !== null && (objeto as IWebHttpErroResponse).type == "HttpErroExceptionModel";
    } 
}